export default __webpack_public_path__ + "static/CBX_IconShuttle-0b766e25ab4fa16501b556c378d83f05.png";